<template>
  <slot name="header" v-bind="{ open, setRef }"></slot>
  <transition
    name="accordion"
    @enter="startTransition"
    @after-enter="endTransition"
    @before-leave="startTransition"
    @after-leave="endTransition"
  >
    <div class="accordion__content" v-show="visible">
      <slot name="content"></slot>
    </div>
  </transition>
</template>

<script>
export default {
  inject: ['accordionState'],
  data() {
    return {
      index: null,
      itemRef: null,
    }
  },
  computed: {
    visible() {
      return this.index === this.accordionState.active
    }
  },
  methods: {
    open() {
      if (this.visible) {
        this.accordionState.active = null
      } else {
        this.accordionState.active = this.index

        if (this.itemRef) {
          setTimeout(() => {
            if (this.itemRef) {
              this.itemRef.scrollIntoView({ behavior: 'smooth' })
            }
          }, 300)
        }
      }
    },
    startTransition(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    endTransition(el) {
      el.style.height = ''
    },
    setRef(el) {
      this.itemRef = el
    }
  },
  created() {
    this.index = this.accordionState.count++
  }
}
</script>

<style lang="scss" scoped>
  .accordion-enter-active,
  .accordion-leave-active {
    will-change: height, opacity;
    //transition: height 0.1s ease, opacity 0.1s ease;
    overflow: hidden;
  }

  .accordion-enter-from,
  .accordion-leave-to {
    height: 0 !important;
    opacity: 0;
  }
</style>
